<template>
  <div>
    <div class="mb-6 flex flex-nowrap items-center">
      <h1 class="mr-3 text-2xl text-gray-777 font-roboto uppercase">Formulários</h1>
      <font-awesome-icon icon="fa-cog" class="text-gray-600 text-lg cursor-pointer" @click.prevent="openModalConfig" />
    </div>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/forms/' + patient.id"
      no-data-label="Nenhum formulário cadastrado"
      no-result-label="Nenhum formulário encontrado"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <span @click="openModal(row)"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></span>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-1 gap-4 ">
          <span @click="openModal(row)"><font-awesome-icon icon="fa-eye" class="text-green-500 text-lg cursor-pointer" /></span>
        </div>
      </template>
    </data-table>
    <modal ref="modal" size="modal-lg" :modal-scrollable="true">
      <template #header>
          <div class="text-gray-777 font-roboto uppercase">
              <span>{{ $filters.formatDateTime(selectedItem.date) }} - {{ selectedItem.form.name }} <span v-if="selectedItem.score"> - {{ selectedItem.score }}</span></span>
          </div>
      </template>
      <template #body>
        <div class="mb-2 pb-2 border-b" v-for="(question, index) in selectedItem.questions">
          <div class="font-bold">{{ question.question.order }} - {{ question.question.question }}</div>
          <div v-if="question.form_question_answer && (question.question.type == 'caixa_selecao' || question.question.type == 'multipla_escolha')">
            <div v-for="(answer, index) in question.form_question_answer">
              {{ answer.answer }} - <span class="font-bold">Score:</span> {{ answer.score }}
            </div>
          </div>
          <div v-else>{{ question.answer }}</div>
        </div>
      </template>
      <template #footer>
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModal">Fechar</button>
      </template>
    </modal>
    <modal ref="modalConfig" size="modal-lg">
      <template #header>
          <div class="text-gray-777 font-roboto uppercase">
              <span>Formulários - Configurações - {{ patient.user.name }}</span>
          </div>
      </template>
      <template #body>
        <form action="">
          <button class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="this.formSchedulers.schedulers.push({frequency: null});">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /> Adicionar Formulário
          </button>
          <div class="mt-6 mb-2 p-1 bg-gray-100/50 flex flex-wrap" v-for="(form_scheduler, index) in this.formSchedulers.schedulers">
            <vue-select-input v-model="form_scheduler.form" :options="forms" :error="this.formSchedulers.errors[`schedulers.`+index+`.form.id`]" class="lg:pr-6 w-full lg:w-5/12" placeholder="Formulário" text="nenhum formulário encontrado" />
            <mask-input mask="#####" v-model="form_scheduler.repeat" :error="this.formSchedulers.errors[`schedulers.`+index+`.repeat`]" class="w-full mt-6 lg:mt-0 lg:pr-6 lg:w-3/12" placeholder="Repetições" />
            <select-input v-model="form_scheduler.frequency" :error="this.formSchedulers.errors[`schedulers.`+index+`.frequency`]" class="w-5/6 mt-6 lg:mt-0 lg:pr-6 lg:w-3/12" placeholder="Frequência">
              <option :value="null" disabled class="hidden invisible">Frequência</option>
              <option v-for="(value, name, index) in frequencies" :key="name" :value="name">{{ value }}</option>
            </select-input>
            <div class="mt-6 lg:mt-0 w-1/6 lg:w-1/12 self-center text-center">
              <span @click="deleteConfigForm(this.formSchedulers.schedulers, form_scheduler)"><font-awesome-icon icon="fa-xmark" class="text-gray-600 text-lg cursor-pointer" /></span>
            </div>
          </div>
        </form>
      </template>
      <template #footer>
          <button type="button" class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out" @click.prevent="closeModalConfig">Cancelar</button>
          <loading-button :loading="loadModalConfig" class="btn-blue px-6 py-2.5 text-xs leading-tight uppercase ml-1" @click.prevent="saveModalConfig" type="submit">Salvar</loading-button>
      </template>
    </modal>
  </div>
</template>

<script>
import { computed } from 'vue'
import { usePage, useForm } from '@inertiajs/inertia-vue3'
import Modal from '@/Shared/Modal'
import DataTable from '@/Shared/DataTable'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import VueSelectInput from '@/Shared/VueSelectInput'
import MaskInput from '@/Shared/MaskInput'

export default {
  inject: ['patient'],
  components: {
    Modal,
    DataTable,
    LoadingButton,
    SelectInput,
    TextInput,
    VueSelectInput,
    MaskInput,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user);
    return {
      user,
    }
  },
  data() {
    return {
      loadModalConfig: false,
      selectedItem: Object,
      loadTable: true,
      forms: {},
      frequencies: {},
      form_schedulers: {},
      formSchedulers: {},
      columns: [
        {
          uniqid: 'form_date',
          label: 'Data',
          field: 'date',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDateTime(row.date),
        },
        {
          uniqid: 'form_name',
          label: 'Formulário',
          field: 'forms.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.form.name ? row.form.name : ''
        },
        {
          uniqid: 'form_description',
          label: 'Descrição',
          field: 'forms.description',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.form.description ? row.form.description.substr(0, 50) : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  mounted() {
    this.loadOptions();
  },
  methods: {
    async loadOptions() {
      await fetch(
        `/patients/forms/get-options/` + this.patient.id
      ).then(res => {
        res.json().then(json => {
          this.forms = json.forms;
          this.form_schedulers = json.form_schedulers;
          this.frequencies = json.patient_form_scheduler_frequencies;
        });
      });
    },
    openModal(item) {
      item.questions.sort((a, b) => (a.question.order > b.question.order ? 1 : (a.question.order < b.question.order ? -1 : 0)))
      this.selectedItem = item;
      this.$refs.modal.showModal = true;
    },
    closeModal() {
      this.$refs.modal.showModal = false;
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    openModalConfig() {
      this.formSchedulers = useForm({schedulers: this.form_schedulers});
      this.$refs.modalConfig.showModal = true;
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false;
    },
    saveModalConfig() {
      this.formSchedulers.post(`/patients/forms/` + this.patient.id, {
        onFinish: () => {
            if(!Object.keys(this.formSchedulers.errors).length) {
                this.closeModalConfig();
                this.loadOptions();
            } else {
                this.loadModalConfig = false;
            }
        }
      });
    },
    deleteConfigForm(schedulers, scheduler) {
      schedulers.splice(schedulers.indexOf(scheduler), 1);
    },
  },
}
</script>